import Repository from './Repository.js';

class ProviderRepository extends Repository {
    async getAvailables() {
        return await this.get('providers', {}, false);
    }
}

export default new ProviderRepository();
